import React from "react";
import RootRouter from "./routes/RootRouter";

export default function App() {
  return (
    <RootRouter />
  );
}
